import { FuelTextField } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const TextField = styled(FuelTextField)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  .text-field__input {
    text-transform: uppercase;
  }
`
